
<template>
    <el-dialog :title="title" append-to-body :visible.sync="dialogFormVisible">
            <el-input type="textarea" v-model="formData.tips"></el-input>
        <span slot="footer" class="dialog-footer">
            <el-button size="mini" @click="dialogFormVisible = false">取 消</el-button>
            <el-button size="mini" type="primary" @click="formSubmit">确 定</el-button>
        </span>
    </el-dialog>
</template>
<script>
import {addBlack} from '@/api/admin/workerUser'
import waves from '@/directive/waves/index.js' // 水波纹指令
import { objKeySort } from '@/util/ajaxsign'
export default {
    name: 'black',
    directives: {
        waves
    },
    data() {
        return {
            title : '移入原因',
            dialogFormVisible:false,
            userName:'',
            formData:{
                tips:'',
                workerId:'',
                urId:''
            }
        }
    },
    created() {},
    methods: {
        //查看数据展示
        setUserId(workerId,urId,userName){
            this.formData.workerId = workerId;
            this.formData.urId = urId;
            this.dialogFormVisible = true;
            this.userName = userName;
        },
        formSubmit(){
            this.$emit('refreshblack');
            this.dialogFormVisible = false;
            addBlack(objKeySort(this.formData)).then(response => {
                if(response&&response.data&&response.data.code===200){
                    this.$message({
                        title: '成功',
                        message: '移入黑名单成功',
                        type: 'success',
                        duration: 2000
                    })
                    this.$emit('refreshblack');
                    this.formData.tips='';
                    this.dialogFormVisible = false;
                }else{
                        this.$message({
                        title: '失败',
                        message: '移入黑名单失败',
                        type: 'error',
                        duration: 2000
                    })
                }
            });
        }


    }
}
</script>

<style lang="scss" scoped>

</style>
